import { fetchAuthSession } from "aws-amplify/auth";
import axios, { AxiosResponse } from "axios";
// import AuthTokenHelper from "./AuthHelper";

// const userId = AuthTokenHelper.getUserId();

// export default function setUpAxios(axios: AxiosInstance) {
//   axios.defaults.baseURL = process.env.REACT_APP_API_URL;
//   axios.interceptors.request.use(
//     async (config: any) => {
//       let id_token = (await Auth.currentSession()).getIdToken().getJwtToken();
//       // let access_token = (await Auth.currentSession()).getAccessToken().getJwtToken();
//       config.headers['Content-Type'] = 'application/json';
//       config.headers['Cache-Control'] = "no-cache";
//       config.headers['source'] = "providerPortal";
//       config.headers['userId'] = userId;
//       config.headers.Authorization = `Bearer ${id_token}`;
//       return config;
//     },
//     (err: AxiosError) => Promise.reject(err)
//   );
//   axios.interceptors.response.use((res: AxiosResponse)=>{return res}, (err: AxiosError)=>{
//     if(401 === err!.response!.status){
//       toast.warning(err.code+": "+err.message);
//       var data = err.response?.data;
//       return data;
//     }else{
//       toast.error(err.code+": "+err.message);
//     }
//   });
// }

const maxRetryAttempts = 3;
const retryDelay = 1000;


const axiosWithToken = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});
axiosWithToken.interceptors.request.use(async (config: any) => {
  const { tokens } = await fetchAuthSession();
  let id_token = tokens?.idToken;
  config.headers['Content-Type'] = 'application/json';
  config.headers.Authorization = `Bearer ${id_token}`;

  return config;
});

axiosWithToken.interceptors.response.use((res: AxiosResponse) => { return res }, (err: any) => {
  const { config } = err;
  if (401 === err!.response!.status) {
    // toast.warning(err.code + ": " + err.message);
    // let data = err.response?.data;
    return err.response;
  } else if (429 === err!.response!.status || err!.response!.status >= 500) {
    if (!config.retry) {
      err.config.retry = 1
    } else if (config.retry >= maxRetryAttempts) {
      // return Promise.reject(err);
      // let data = err.response?.data;
      return err.response;
    } else {
      config.retry += 1;
    }
    // return axiosWithAPIKey.request;
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(axiosWithToken(config));
        console.log("retry axiosWithToken");
      }, retryDelay);
    });
  } else {
    // toast.error(err.code + ": " + err.message);
    // let data = err.response?.data;
    return err.response;
  }
});

const api_key = process.env.REACT_APP_APIKEY;
const axiosWithAPIKey = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

axiosWithAPIKey.interceptors.request.use((config: any) => {
  config.headers['Content-Type'] = 'application/json';
  config.headers['x-api-key'] = api_key;
  return config;
});

axiosWithAPIKey.interceptors.response.use((res: AxiosResponse) => { return res }, (err: any) => {
  const { config } = err;
  if (401 === err!.response!.status) {
    // toast.warning(err.code + ": " + err.message);
    // let data = err.response?.data;
    return err.response;
  } else if (429 === err!.response!.status || err!.response!.status >= 500) {
    if (!config.retry) {
      console.log("if not retry");
      err.config.retry = 1
    } else if (config.retry >= maxRetryAttempts) {
      // return Promise.reject(err);
      // let data = err.response?.data;
      return err.response;
    } else {
      console.log("increasing counter");
      config.retry += 1;
    }
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(axiosWithAPIKey(config));
        console.log("retry axiosWithAPIKey");
      }, retryDelay);
    });
  } else {
    // toast.error(err.code + ": " + err.message);
    // let data = err.response?.data;
    return err.response;
  }
});

export { axiosWithAPIKey, axiosWithToken };
